import React from "react";
import PropTypes from "prop-types";

import "features/application/reasons-to-join/view.scss";

const ReasonsToJoinView = ({
  userData,
  reasons,
  error,
  toggleCheck,
  sendApiRequest,
}) => (
  <div className="form__content reasons-to-join__content">
    <h1 className="application__headline reasons-to-join__headline reasons-to-join__elongation">
      Reasons to Join
    </h1>
    <p className="reasons-to-join__description reasons-to-join__elongation">
      Please tell us the main reasons you would like to join Parlor Social Club.
      This will help us personalize your experience (you can check a maximum of
      3 boxes):
    </p>
    {reasons &&
      reasons.map((reason) => (
        <button
          className={`reasons-to-join__item${
            reason.is_selected
              ? "--checked"
              : reason.id === error
              ? "--error"
              : ""
          }`}
          type="button"
          key={reason.id}
          data-reason={reason.id}
          onClick={toggleCheck}
          dangerouslySetInnerHTML={{ __html: reason.name }}
        />
      ))}
    <p className="reasons-to-join__description reasons-to-join__elongation">
      {userData.is_referred
        ? "On the next pages we’ll ask some brief questions."
        : "On the next pages we’ll ask some brief questions. At the end you’ll be able to select the membership plan that you want. We look forward to learning more about you."}
    </p>
    <div className="application__buttons reasons-to-join__elongation">
      <button
        className="application__button"
        type="submit"
        onClick={sendApiRequest}
      >
        Next
      </button>
    </div>
  </div>
);

ReasonsToJoinView.propTypes = {
  userData: PropTypes.object,
  reasons: PropTypes.array,
  error: PropTypes.number,
  toggleCheck: PropTypes.func,
  sendApiRequest: PropTypes.func,
};

export default ReasonsToJoinView;
